import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Divider,
  Button,
  Card,
  CardContent,
  TextField,
  CardHeader,
  CircularProgress
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import React, { Component } from 'react';
import SearchRecords from './SearchRecords';
import RequestChart from 'src/components/pages/vaccination/dashboard/RequestChart';
import StatusCount from 'src/components/pages/vaccination/dashboard/StatusCount';
import masterStatus from 'src/models/medicine';
import Traffic from 'src/components/pages/vaccination/dashboard/TrafficByType';
import { _axios } from 'src/plugins/axios';
import moment from 'moment';
import * as _ from 'lodash';
import theme from 'src/theme';
import Report from '@mui/icons-material/Report';
import Beenhere from '@mui/icons-material/Beenhere';
import Cancel from '@mui/icons-material/Cancel';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import OfflinePin from '@mui/icons-material/OfflinePin';
import commonService from 'src/service/common';
import goodalipi from 'src/plugins/goodalipi';
import Count from 'src/components/pages/ahc/ahcEmployees/count';
import { Bar } from 'react-chartjs-2';
const masterStatusCount = JSON.parse(JSON.stringify(masterStatus));

const iconMapping = {
  AttendedCount: <Beenhere fontSize="large" style={{ color: 'white' }} />,
  CanceledCount: <Cancel fontSize="large" style={{ color: 'white' }} />,
  ConfirmedCount: <OfflinePin fontSize="large" style={{ color: 'white' }} />,
  NewAppointmentCount: (
    <PermContactCalendarIcon fontSize="large" style={{ color: 'white' }} />
  ),
  NotAttendedCount: <Report fontSize="large" style={{ color: 'white' }} />
};

let today = new Date();
let startOfYearDate = new Date(today.getFullYear(), 0, 1);
const daysToPreFetch = Math.floor((today.getTime() - startOfYearDate.getTime()) / (1000 * 60 * 60 * 24));

class MedicineDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        dateRange: [],
        campLocation: [],
        providerName: [],
        campType: [],
        benf: [],
        payment: '',
        entityRequested: ''
      },
      filterOptions: {
        campLocationList: [],
        providerNameList: [],
        campTypeList: [],
        paymetnList: [],
        benfList: [],
        entityRequested: goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : []
      },
      officeCampusRequests: [],
      hospitalRequests: [],
      masterDataCountItems: [],
      gender_age: null,
      deliveryType: null,
      periodWiseCount: null,
      periodWiseCount: {},
      uniqueOrders: null,
      salesChartOptions: {
        view: null,
        data: null
      },
      groupChartOptions: {
        gender: null,
        relation: null
      },
      error: {
        piechart: false
      },
      userCount: 0,
      // uniqueEmployees: 0,
      utilizationCount: 0
    };
    this.DeliveryType = React.createRef();
    this.ageWiseRef = React.createRef();
    // this.options = {
    //   animation: {
    //     duration: 1,
    //     onComplete: () => {
    //       console.log(this.ageWiseRef);
    //       let baseImg =
    //         this.ageWiseRef && this.ageWiseRef.current
    //           ? this.ageWiseRef.current.toBase64Image()
    //           : null;
    //       console.log(baseImg);
    //     }
    //   },
    //   indexAxis: 'y',
    //   cornerRadius: 20,
    //   layout: {
    //     padding: 0
    //   },
    //   maintainAspectRatio: false,
    //   responsive: true,
    //   interaction: {
    //     intersect: false,
    //     mode: 'y'
    //   },
    //   plugins: {
    //     legend: {
    //       display: false
    //     },
    //     tooltip: {
    //       callbacks: {
    //         title: function (tooltipItem) {
    //           return tooltipItem[0].label.replace(',', ' ');
    //         },
    //         footer: function (tooltipItems) {
    //           let sum = 0;
    //           if (tooltipItems.length == 1) {
    //             return;
    //           }
    //           tooltipItems.forEach(function (tooltipItem) {
    //             sum += tooltipItem.parsed.x;
    //           });
    //           return 'Total: ' + sum;
    //         }
    //       }
    //     }
    //   },
    //   scales: {
    //     x: {
    //       ticks: {
    //         color: '#aaaaaa'
    //       },
    //       stacked: true,
    //       grid: {
    //         drawBorder: false,
    //         borderDash: [2],
    //         borderDashOffset: [2]
    //       }
    //     },
    //     y: {
    //       stacked: true,
    //       ticks: {
    //         color: theme.palette.secondary.main,
    //         beginAtZero: true,
    //         min: 0
    //       },
    //       grid: {
    //         display: false,
    //         drawBorder: false
    //       }
    //     }
    //   }
    // };
  }

  downloadImage() {
    console.log(this.DeliveryType);
    const base64Image = DeliveryType.current.toBase64Image();
  }
  //refresh data
  applyFilters() {
    const payload = {};
    if (this.state.filter.campLocation.length)
      payload.campLocation = this.state.filter.campLocation;
    if (this.state.filter.campType.length)
      payload.campType = this.state.filter.campType;
    if (this.state.filter.providerName.length)
      payload.providerName = this.state.filter.providerName;
    if (this.state.filter.payment) payload.payment = this.state.filter.payment;
    if (this.state.filter.benf.length) payload.benf = this.state.filter.benf;
    if (this.state.filter.dateRange.length == 2) {
      let startDate = new Date(this.state.filter.dateRange[0]);
      let endDate = new Date(this.state.filter.dateRange[1]);
      payload['apptDateBegin'] =
        startDate.getFullYear() +
        '-' +
        ('0' + (startDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + startDate.getDate()).slice(-2);
      payload['apptDateEnd'] =
        endDate.getFullYear() +
        '-' +
        ('0' + (endDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + endDate.getDate()).slice(-2);
    }
    if (this.state.filter.entityRequested) {
      payload.globalHR = true;
      payload.entityRequested = this.state.filter.entityRequested;
    }
    this.refreshChartOption(daysToPreFetch, { ...payload });
    this.refreshTypeCount({ ...payload });
    this.refreshData({ ...payload });
    this.getUserCount(daysToPreFetch, { ...payload })
    // this.getUniqueEmployees(daysToPreFetch, { ...payload })
    // this.getUtilizationCount(daysToPreFetch, { ...payload })
  }

  refreshData(payLoad = {}) {
    // if(sessionStorage.getItem('statuscount') && _.keys(payLoad).length==0) {
    //   this.setState({
    //     masterDataCountItems: JSON.parse(sessionStorage.getItem('statuscount')).masterDataCountItems
    //   })
    //   return
    // }
    payLoad.statType = 'day';
    this.setState(
      {
        masterDataCountItems:
          goodalipi.get('isMinor') == 'isBooleantrue'
            ? _.filter(
              JSON.parse(JSON.stringify(masterStatusCount)),
              function (o) {
                return (
                  o.statusName != 'Cancelled' && o.statusName != 'NotAttended'
                );
              }
            )
            : JSON.parse(JSON.stringify(masterStatusCount))
      },
      () => {
        _axios
          .post('pharma/getAllTypeCount', payLoad, {
            ignoreLoading: true
          })
          .then((response) => {
            if (response.data) {
              const data = [...this.state.masterDataCountItems];
              _.keysIn(response.data.result).forEach((key) => {
                if (key != 'isSuccess') {
                  data.forEach((status, idx) => {
                    status.totalCount += response.data.result[key][
                      status.statusName
                    ]
                      ? response.data.result[key][status.statusName]
                      : 0;
                  });
                }
              });
              data.forEach((data) => {
                data.totalCount = data.totalCount ? data.totalCount : 'NA';
              });
              delete payLoad.statType;
              if (_.keys(payLoad).length == 0 && response.data.isSuccess) {
                sessionStorage.setItem(
                  'statuscount',
                  JSON.stringify({
                    masterDataCountItems: data
                  })
                );
              }
              this.setState({
                masterDataCountItems: data
              });
            }
          })
          .catch((error) => {
            // alert(error);
          });
      }
    );
  }

  //total status count call

  refreshChartView(days) {
    const salesOptions = this.state.salesChartOptions;
    this.setState({
      salesChartOptions: {
        data: salesOptions.data,
        view: {
          datasets: salesOptions.data.datasets.map((each) => {
            console.log('zzzz: ', each, days);
            let option = Object.assign({}, each);
            option.data = each.data.slice(-days);
            return option;
          }),
          labels: salesOptions.data.labels.slice(-days)
        }
      }
    });
  }
  //bar graph call
  refreshChartOption(till, payload = {}) {
    let lastSelectedDays = {};
    if (
      moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days') <
      14 &&
      payload.apptDateEnd
    ) {
      till = moment(payload.apptDateEnd).diff(
        moment(payload.apptDateBegin),
        'days'
      );
    }
    _.forEach(
      [...Array(till).keys()].reverse().map((value) => value + 1),
      (days) => {
        lastSelectedDays[
          moment(payload.apptDateEnd).subtract(days, 'd').format('YYYY-MM-DD')
        ] = {};
      }
    );
    payload.statType = 'day';
    if (!payload.apptDateEnd) {
      payload.apptDateBegin = moment().subtract(till, 'd').format('YYYY-MM-DD');
      payload.apptDateEnd = moment().subtract(1, 'd').format('YYYY-MM-DD');
    }
    // console.log(moment(payload.apptDateEnd), moment(payload.apptDateBegin))
    // console.log(moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days'))
    // console.log(payload)
    // console.log(lastSelectedDays)
    // return
    this.setState({
      salesChartOptions: {
        view: null,
        data: null
      }
    });
    _axios
      .post('pharma/getAllTypeCount', payload, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      })
      .then((response) => {
        // if(response.data && response.data.isSuccess){
        //     response.data.result.forEach((data) => )

        // }
        if (response.data) {
          let dateMapCount = {};
          Object.keys(response.data.result).forEach((date) => {
            let key = moment(date).format('DD-MMM');
            dateMapCount[key] = response.data.result[date];
          });
          const data = {
            labels: [],
            datasets: []
          };
          let totalOrderCount = [];
          console.log('dateMapCount', dateMapCount);
          Object.keys(lastSelectedDays).forEach((each) => {
            let key = moment(each).format('DD-MMM');
            data.labels.push(key);
            totalOrderCount.push(dateMapCount[key] ? dateMapCount[key] : 0);
          });
          data.datasets = (
            goodalipi.get('isMinor') == 'isBooleantrue'
              ? _.filter(masterStatusCount, function (o) {
                return o.statusName == 'Total' || o.statusName == 'Delivered';
              })
              : masterStatusCount
          ).map((value) => {
            return {
              label: value.status,

              data: Object.values(totalOrderCount).map((each) =>
                each[value.statusName] ? each[value.statusName] : 0
              ),
              backgroundColor: value.darkColor,
              barThickness: 8,
              maxBarThickness: 6,
              minBarLength: 2
            };
          });

          this.setState({
            salesChartOptions: {
              view: data,
              data
            }
          });
          delete payload.statType;
          delete payload.apptDateBegin;
          delete payload.apptDateEnd;
          if (_.keys(payload).length == 0) {
            // sessionStorage.setItem('salesChartOptions', JSON.stringify({
            //   view: data,
            //   data
            // }))
          }
        }
      })
      .catch((error) => {
        //alert(error);
      });
  }

  //donought charts call
  refreshTypeCount(payLoad = {}) {
    // if(sessionStorage.getItem('groupChartOptions') && _.keys(payLoad).length==0) {
    //   this.setState({
    //     groupChartOptions: JSON.parse(sessionStorage.getItem('groupChartOptions'))
    //   })
    //   return
    // }
    // payLoad = {
    //   "apptDateBegin": null,
    //   "apptDateEnd": null,
    // }
    this.setState({
      groupChartOptions: {
        gender: null,
        relation: null
      },
      error: {
        piechart: false
      }
    });
    this.state.error.piechart = true;
    _axios
      .post('pharma/beneficaryBookings', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data) {
          const gender = {
            Male: 0,
            Female: 0
          };
          //Relation
          let relation = { 'Self': 0, 'Spouse': 0, Parents: 0, Others: 0 }
          // = [ {relation : 'Self', count :  0},{relation : 'Spouse', count :  0},{relation : 'Parents', count :  0},{relation : 'Others', count :  0} ];
          if (response.data && response.data.relation) {

            Object.keys(response.data.relation).map((data) => {
              console.log("relation wise==>", data, response.data.relation[data]);
              if (data == 'Self' || data == 'You' || data == 'Myself') {
                relation['Self'] += response.data.relation[data]
              }
              else if (data == 'Father' || data == 'Mother' || data == 'Father-in-law' || data == 'Mother-in-law') {
                relation['Parents'] += response.data.relation[data]
              }
              else if (data == 'Spouse' || data == 'Wife' || data == 'Husband' || data == 'Spouse / Partner' || data == 'Spouse / Domestic Partner') {
                relation['Spouse'] += response.data.relation[data]
              }
              else {
                relation['Others'] += response.data.relation[data]
              }


              // return {
              //   relation: data,
              //   count: response.data.relation[data]
              // };
            });
            relation = Object.keys(relation).map((key) => {
              return { relation: key, count: relation[key] }
            })
          }
          //Gender
          if (response.data.genCount) {
            let totalCount = 0;
            Object.keys(response.data.genCount).forEach((data) => {
              totalCount += response.data.genCount[data];
            });
            Object.keys(response.data.genCount).forEach((each) => {
              if (['f', 'female'].indexOf(each.toLowerCase()) > -1) {
                gender.Female += response.data.genCount[each];
              } else if (['m', 'male'].indexOf(each.toLowerCase()) > -1) {
                gender.Male += response.data.genCount[each];
              }
            });
          }

          //Status Count
          // const countData = [...masterStatusCount];
          // countData.forEach((data) => {
          //   data.totalCount = response.data[data.statusName]
          //     ? response.data[data.statusName]
          //     : 0;
          // });
          this.setState({
            // masterDataCountItems: countData,
            uniqueOrders: response.data.uniqueOrders,
            groupChartOptions: {
              gender: {
                data: [gender.Male, gender.Female],
                labels: Object.keys(gender)
              },
              relation
            },
            gender_age: {
              labels: response.data.age ? Object.keys(response.data.age) : [],
              datasets: [
                {
                  data: response.data.age
                    ? Object.values(response.data.age)
                    : [],
                  backgroundColor: '#1778f2',
                  barPercentage: 0.5,
                  maxBarThickness: 10,
                  minBarLength: 3
                }
              ]
            },
            deliveryType: {
              labels: response.data.deliveryType
                ? Object.keys(response.data.deliveryType)
                : [],
              datasets: [
                {
                  data: response.data.deliveryType
                    ? Object.values(response.data.deliveryType)
                    : [],
                  backgroundColor: '#1778f2',
                  barPercentage: 0.5,
                  maxBarThickness: 10,
                  minBarLength: 3
                }
              ]
            },
            periodWiseCount: {
              labels: response.data.periodWiseCount
                ? Object.keys(response.data.periodWiseCount)
                : [],
              datasets: [
                {
                  data: response.data.periodWiseCount
                    ? Object.values(response.data.periodWiseCount)
                    : [],
                  backgroundColor: '#1778f2',
                  barPercentage: 0.5,
                  maxBarThickness: 10,
                  minBarLength: 3
                }
              ]
            }
          });
          if (_.keys(payLoad).length == 0) {
            sessionStorage.setItem(
              'groupChartOptions',
              JSON.stringify({
                gender: {
                  data: [gender.Male, gender.Female],
                  labels: Object.keys(gender)
                },
                relation
              })
            );
          }
        }
      })
      .catch((error) => {
        //alert(error);
        this.setState({
          error: {
            piechart: true
          }
        });
      });
  }

  getUserCount = (daysToPreFetch, payload = {}) => {
    payload = this.setInitialPayload(daysToPreFetch, payload)

    this.setState({ userCount: null })
    _axios.post('/pharma/usersCount', payload, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response?.data?.isSuccess) {
        if (response.data.result?.length)
          this.setState({
            userCount: response.data.result[0]?.users
          })
      }
      else
        throw new Error('Something went wrong - getUserCount');
    }).catch(err => {
      console.log(err.message);
    })
  }

  //this is on hold as the query is not correct
  // getUniqueEmployees = (daysToPreFetch, payload = {}) => {
  //   payload = this.setInitialPayload(daysToPreFetch, payload);

  //   this.setState({ uniqueEmployees: null })
  //   _axios.post('/pharma/employeesLoginCount', payload, {
  //     ignoreLoading: true,
  //     headers: {
  //       authtoken: commonService.getAuthToken(),
  //       'Content-Type': 'application/json'
  //     }
  //   }).then((response) => {
  //     if (response?.data?.isSuccess) {
  //       if (response.data.result?.length)
  //         this.setState({
  //           uniqueEmployees: response.data.result[0]?.Employees
  //         })
  //     }
  //     else
  //       throw new Error('Something went wrong - getUniqueEmployees');
  //   }).catch(err => {
  //     console.log(err.message);
  //   })
  // }

  getUtilizationCount = (daysToPreFetch, payload = {}) => {
    payload = this.setInitialPayload(daysToPreFetch, payload);

    this.setState({ utilizationCount: null });
    _axios.post('/pharma/utilizationCount', payload, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response?.data?.isSuccess) {
        if (response.data.result?.length)
          this.setState({
            utilizationCount: response.data.result[0]?.User_Used_Atleast_Once
          })
      }
      else
        throw new Error('Something went wrong - getUtilizationCount');
    }).catch(err => {
      console.log(err.message);
    })
  }

  setInitialPayload = (till, payload) => {
    let lastSelectedDays = {};
    if (
      moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days') <
      14 &&
      payload.apptDateEnd
    ) {
      till = moment(payload.apptDateEnd).diff(
        moment(payload.apptDateBegin),
        'days'
      );
    }
    _.forEach(
      [...Array(till).keys()].reverse().map((value) => value + 1),
      (days) => {
        lastSelectedDays[
          moment(payload.apptDateEnd).subtract(days, 'd').format('YYYY-MM-DD')
        ] = {};
      }
    );
    payload.statType = 'day';
    if (!payload.apptDateEnd) {
      payload.apptDateBegin = moment().subtract(till, 'd').format('YYYY-MM-DD');
      payload.apptDateEnd = moment().subtract(1, 'd').format('YYYY-MM-DD');
    }
    return payload;
  }

  componentDidMount() {
    this.refreshTypeCount();
    this.refreshChartOption(daysToPreFetch);
    this.refreshData();
    this.getUserCount(daysToPreFetch);
    // this.getUniqueEmployees(daysToPreFetch);
    // this.getUtilizationCount(daysToPreFetch);
  }

  componentDidCatch() {
    console.log('test');
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Medicine | Dashboard</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <SearchRecords
              filterOptions={this.state.filterOptions}
              filter={this.state.filter}
              setFilters={(value) => this.setState({ filter: value })}
              onRefresh={() => this.applyFilters()}
            />

            <Grid container alignItems="stretch" spacing={2}>
              <Grid item container lg={8} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    pt: 2,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardContent>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-around"
                      spacing={3}
                    >
                      {this.state.masterDataCountItems.map((each, idx) => {
                        let display = goodalipi.get('isMinor') == 'isBooleantrue';
                        display = display && !each.showForHR;
                        return (!display &&
                          <Grid
                            item
                            lg={4}
                            sm={6}
                            xl={4}
                            xs={12}
                            md={4}
                            key={idx}
                          >
                            <Count
                              status={each}
                              loading={
                                this.state.masterDataCountItems.length == 0
                              }
                              server={true}
                            />
                          </Grid>
                        )
                      })}
                      <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                        <Count
                          status={{
                            statusName: 'uniqueOrders',
                            status: 'No. of Active Employees',
                            bgColor: '#fff',
                            totalCount: this.state.uniqueOrders,
                            statusId: [32],
                            darkColor: '#40d9c4'
                          }}
                          loading={this.state.uniqueOrders == 0}
                          server={true}
                        ></Count>
                      </Grid>
                      <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                        <Count
                          status={{
                            statusName: 'userCount',
                            status: 'No. of Employees Added',
                            bgColor: '#fff',
                            totalCount: this.state.userCount,
                            statusId: [32],
                            darkColor: '#D1B296'
                          }}
                          loading={this.state.userCount == 0}
                          server={true}
                        ></Count>
                      </Grid>
                      {/* <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                        <Count
                          status={{
                            statusName: 'uniqueEmployees',
                            status: 'Unique Employees',
                            bgColor: '#fff',
                            totalCount: this.state.uniqueEmployees,
                            statusId: [32],
                            darkColor: '#84AE9E'
                          }}
                          loading={this.state.uniqueEmployees == 0}
                          server={true}
                        ></Count>
                      </Grid> */}
                      {/* <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                        <Count
                          status={{
                            statusName: 'utilizationCount',
                            status: 'No. of Active Employees',
                            bgColor: '#fff',
                            totalCount: this.state.utilizationCount,
                            statusId: [32],
                            darkColor: '#936388'
                          }}
                          loading={this.state.utilizationCount == 0}
                          server={true}
                        ></Count>
                      </Grid> */}
                    </Grid>
                    <Grid item mt={5}>
                      <RequestChart
                        data={this.state.salesChartOptions.view}
                        refreshBarChart={(till) => {
                          this.refreshChartView(till);
                        }}
                        isHeaderRequired={true}
                      />
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item container lg={4} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <Traffic
                    sx={{ height: '100%', width: '100%' }}
                    onRefresh={() => this.refreshTypeCount()}
                    serverError={this.state.error.piechart}
                    chartOptions={this.state.groupChartOptions}
                  />
                </Card>
                {/* adding */}

                {/* added */}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardHeader title="Delivery Type" />
                  <CardContent>
                    <PerfectScrollbar>
                      <Box
                        sx={{
                          height: '200px',
                          width: '100%'
                        }}
                        className="display-center"
                      >
                        {!this.state.deliveryType ? (
                          <CircularProgress size={30} />
                        ) : (
                          <VerticalBarGraph data={this.state.deliveryType} />
                        )}
                      </Box>
                    </PerfectScrollbar>
                  </CardContent>
                </Card>
              </Grid>
              {/* {<Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardHeader title="Age Wise Count" />
                  <CardContent>
                    <PerfectScrollbar>
                      <Box
                        sx={{
                          height: '200px',
                          width: '100%'
                        }}
                        className="display-center"
                      >
                        {!this.state.gender_age ? (
                          <CircularProgress size={30} />
                        ) : (
                          <VerticalBarGraph data={this.state.gender_age} />
                        )}
                      </Box>
                    </PerfectScrollbar>
                  </CardContent>
                </Card>
              </Grid>} */}
              {/* <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardHeader title="Period Wise Count" />
                  <CardContent>
                    <PerfectScrollbar>
                      <Box
                        sx={{
                          height: '200px',
                          width: '100%'
                        }}
                        className="display-center"
                      >
                        {!this.state.periodWiseCount ? (
                          <CircularProgress size={30} />
                        ) : (
                          <VerticalBarGraph data={this.state.periodWiseCount} />
                        )}
                      </Box>
                    </PerfectScrollbar>
                  </CardContent>
                </Card>
              </Grid> */}
            </Grid>
            {/* added */}
          </Container>
        </Box>
      </>
    );
  }
}
export default MedicineDashboard;
